<template>
<div>
  <div id="reportContainer" style="height:750px; width:100%;"></div>
</div>
</template>

<style>
iframe {
  border: none;
}
</style>

<script>
//import env from "@/configs/environment";
import * as pbi from "powerbi-client";
import axios from "axios";
import { mapGetters} from "vuex";
import BaseModelPowerBIReport from "@/models/BaseModelPowerBIReport.js"
import funcUtil from "@/services/funcUtil.js";

export default {
  name: "report",
  mixins: [funcUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter"])
  },
  data: function() {
    return {
      reportId:"",
      ADToken: null
    };
  },
	mounted() {
    //prod comment
    // this.getReport();
  },
  methods: {
    async getReport() {
      const _this = this;
      let report;
      const dashboardKey = process.env.VUE_APP_PowerBIReportDashboard;

      let query ={filter:"Title eq "+"'"+dashboardKey+"'"}
      let pbiReportResponse= await this.withFilter(BaseModelPowerBIReport.list, query);
      this.reportId =pbiReportResponse[0].ReportGUID;

      const embedTokenCache = "EmbedToken_" + this.reportId;
      const embedUrlCache = "EmbedUrl_" + this.reportId;
      const embedExpirationCache = "EmbedTokenExpiration_" + this.reportId;

      const embedToken = localStorage.getItem(embedTokenCache);
      const embedUrl = localStorage.getItem(embedUrlCache);
      const expiration = localStorage.getItem(embedExpirationCache);

      const nowPlus2Minutes = new Date();
      nowPlus2Minutes.setMinutes(nowPlus2Minutes.getMinutes() + 2);

      if (
        embedToken != null &&
        embedUrl != null &&
        expiration != null &&
        new Date(expiration) > nowPlus2Minutes
      ) {
        report = {
          embedToken: {
            token: embedToken,
            expiration: expiration
          },
          embedUrl: embedUrl,
          id: this.reportId
        };
        console.log("Using Cached IDs")
        console.log(report)
        _this.displayReport(report);
      } else {
        const localStorageKey = `adal.access.token.key${process.env.VUE_APP_server_applicationId}`;
        this.ADToken = localStorage.getItem(localStorageKey);
        try{
        if (this.ADToken) {
        await _this.getEmbedToken(_this.ADToken).then(res => {
          report = {
            embedToken: {
              token: res.EmbedToken.token,
              expiration: res.EmbedToken.expiration
            },
            embedUrl: res.EmbedUrl,
            id: res.Id
          };
          console.log("Using Service Call IDs")
          console.log(report)
          _this.displayReport(report);
          localStorage.setItem(
            embedExpirationCache,
            report.embedToken.expiration
          );
          localStorage.setItem(embedTokenCache, report.embedToken.token);
          localStorage.setItem(embedUrlCache, report.embedUrl);

        })
         }
        }
        catch{
          // let res= await this._ConfirmationPopup("Some Error Occurred.Refresh to fetch the report","REFRESH")
          // if (res.value) {
          //   this.$router.go();
          // }
        }
      }
    },

    displayReport(report) {
      const accessToken = report.embedToken.token;
      const embedUrl = report.embedUrl;
      const embedReportId = report.id;
      let reportContainer = $('#reportContainer')[0];//document.getElementById("reportContainer");
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );

      const embedConfig = {
        type: "report",
        id: embedReportId,
        embedUrl: embedUrl,
        tokenType: pbi.models.TokenType.Embed,
        accessToken: accessToken,
        permissions: pbi.models.Permissions.All,
        pageView: "fitToWidth"
      };

      powerbi.embed(reportContainer, embedConfig);
    },

    async getEmbedToken(token) {
      const reportId = this.reportId
      const auth = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*"
        }
      };
      return axios
        .get(`${process.env.VUE_APP_reportsBaseUrl}/${reportId}`, auth)
        .then(response => response.data);
    }

  }
};
</script>